/**
 * Trunnion AI - Skip Navigation Link
 *
 * Renders a visually hidden anchor that becomes visible on keyboard focus,
 * allowing users to bypass repetitive navigation and jump directly to the
 * main content region. Essential for keyboard and screen-reader accessibility.
 */

export function SkipNavigation() {
  return (
    <a
      href="#main-content"
      className={[
        // Visually hidden by default
        'sr-only',
        // Reveal on focus as a fixed pill
        'focus:not-sr-only',
        'focus:fixed focus:top-2 focus:left-2 focus:z-200',
        // Pill styling
        'bg-trunnion-gold-500 text-trunnion-slate-950',
        'font-semibold px-4 py-2 rounded-lg shadow-lg',
        // Smooth transition
        'focus:outline-none focus:ring-2 focus:ring-trunnion-gold-500 focus:ring-offset-2 focus:ring-offset-trunnion-slate-950',
      ].join(' ')}
    >
      Skip to main content
    </a>
  );
}
